/*
 * @FilePath: config.js
 * @Author: chenwei
 * @Date: 2022-07-07 09:18:17
 * @LastEditors: chenwei
 * @LastEditTime: 2022-08-07 11:00:56
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
 */
// export const proxyHeader = 'api/'
//新海洋环境
// export const proxyHeader = 'http://120.196.115.131:39004/'
// 39001
export const proxyHeader = window.localStorage.getItem('language') === 'en' ? 'http://120.196.115.131:39003/' : 'http://120.196.115.131:39001/'
export const proxyLogout = 'http://120.196.115.131:8082/'
export const mediaView = 'http://120.196.115.131:39001/service/media-service/media/onlineView/?id='
export const mediaDown = 'http://120.196.115.131:39001/service/media-service/media/down?id='
export const iserverHeader = 'http://120.196.115.131:8091'
export const iserverLayerHeader = 'http://120.196.115.131:{s}'

//旧海洋环境
//export const proxyHeader = 'http://139.198.21.233:8180/'
//export const iserverHeader = 'http://192.168.1.8:8090'
//export const proxyHeader = 'http://46a996z478.zicp.vip/'
//export const iserverLayerHeader = 'http://192.168.1.8:{s}'
